module.exports = __webpack_public_path__ + "img/customer_design_3@2x.2be0dc3.webp";